import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ApiCallsService } from '../services/api-calls.service';

@Component({
  selector: 'app-datatable',
  templateUrl: './datatable.component.html',
  styleUrls: ['./datatable.component.scss']
})
export class DatatableComponent implements OnInit {
  feedbackForm!: FormGroup;
  showTable: boolean = false;
  showData: boolean = false;
  isLoading: boolean = false;
  records: any;
  showTooltip: boolean = false;
  showFeedbackReply: boolean = false;
  planType: string = "";
  state: string = "";
  serviceDate: string = "";
  procedureCode: string = "";
  policyNumber: string = "";
  policyDescription: string = "";
  loincDescription: string = "";
  checkedOption: string = "Yes";
  commentAdded: string = "";
  characterCount: any
  addedText: any
  characters: number = 500;
  polices: any = [];

  constructor(private apiCallServices: ApiCallsService, private fb: FormBuilder, private snackBar: MatSnackBar) {}

  ngOnInit(): void {
    this.feedbackForm = this.fb.group({
      ishelpful: [],
      comment: [],
    });
  }

  searchedRecords(tableRecord: any) {
    this.showTable = true;
    let procedureCode = tableRecord.procDetails[0]?.procCd;
    let policyNum = tableRecord.procDetails[0]?.templateID.map((item: {policyNumber: any}) => item.policyNumber);
    let policyLinks = tableRecord.procDetails[0]?.templateID.map((item: {policyLink: any}) => item.policyLink);
    let policyDesc = tableRecord.procDetails[0]?.templateID.map((item: {policyDescription: any}) => item.policyDescription);
    let criteria = tableRecord.procDetails[0]?.templateID.map((item: {criteria: any}) => item.criteria);
    tableRecord.procDetails[0]?.templateID.sort((a: any, b: any) => {
      if(a.useFirst == null && b.useFirst != null){
        return 1;
      }else if(b.useFirst == null && a.useFirst != null){
        return -1;
      }else if(a.useFirst == null && b.useFirst == null){
        return 0;
      }
      return b.useFirst.localeCompare(a.useFirst)
     });
    this.polices = tableRecord.procDetails;
    tableRecord.predictions.map((item: any) => {
      item.procedurecode = procedureCode;
      item.policyLink = policyLinks;
      item.policyNum = policyNum;
      item.policyDesc = policyDesc;
      item.criteria = criteria;
      item.loinccode = item.loINCCodes.map((val: any) => val.loINCCode);
    });
    this.records = tableRecord.predictions;
  }

  showDataTable(value: any) {
    this.showData = value;
    this.showTable = false;
    this.commentAdded = "";
  }

  searchedFormValues(data: any) {
    if(data[0].plantype == "Medicaid") {
      this.planType = "CAID";
    }
    if(data[0].plantype == "Commercial") {
      this.planType = "CSBD";
    }
    if(data[0].plantype == "Medicare") {
      this.planType = "CARE";
    }
    if(data[0].plantype == "FIDE/HIDE") {
      this.planType = "Duals";
    }

    this.state = data[0].state;
    this.serviceDate = data[1];
    this.procedureCode = data[0].pcode;
    this.policyNumber = data[0].policy;
  }

  handleSubmit() {
    if(this.checkedOption !== "" && this.commentAdded !== "") {
      // this.sendFeedback(this.checkedOption, this.commentAdded);
      this.sendSearchLogs(this.planType, this.state, this.serviceDate, this.procedureCode, this.policyNumber, this.checkedOption, this.commentAdded);
    }
  }

  sendSearchLogs(plantype: string, state: string, serviceDate: string, proCode: string, policy: string, isUseful: string, feedback: string) {
    let reqObj = {
      state: state,
      lob: plantype,
      servicedate: serviceDate,
      procedureCode: proCode.toUpperCase(),
      policyNumber: policy,
      tooluseful: isUseful,
      feedback: feedback,
      status: "Success",
      sender: "UI"
    }
    this.isLoading = true;
    this.apiCallServices.searchLogs(reqObj).subscribe((data: any) => {
      console.log("*****search log*****", data);
      this.isLoading = false;
      this.feedbackSnackbar();
      this.commentAdded = "";
    }, (error) => {
      console.log(error);
      this.isLoading = false;
    })
  }

  sendFeedback(isHelpful: string, addedComment: string) {
    let reqObj = {
      feedback: isHelpful,
      comments: addedComment
    }
    this.isLoading = true;
    this.apiCallServices.postFeedback(reqObj).subscribe((data: any) => {
      this.isLoading = false;
      this.feedbackSnackbar();
      this.feedbackForm.patchValue({
        comment: [],
      })
      this.checkedOption = "Yes";
      this.characters = 500;
    }, (error) => {
      this.isLoading = false;
      console.log(error);
    });
  }

  feedbackSnackbar() {
    this.snackBar.open('Thank you for your feedback!', '', {
      duration: 3000,
      panelClass: ['feedback-snackbar'],
    });
  }

  showPolicyToolTip(desc: string){
    this.showTooltip = true;
    this.policyDescription = desc;
  }

  showPLoincToolTip(code: string, val: any){
    this.showTooltip = true;
    this.loincDescription = this.records[val].loINCCodes.filter(item => item.loINCCode == code);
  }

  showCriteriaToolTip(criteria: string){
    // Set description based on criteria type
    let description = "";
    switch(criteria) {
      case 'MCG':
        description = 'Milliman Care Guidelines';
        break;
      case 'LCD':
        description = 'Local Coverage Determination';
        break;
      case 'NCD':
        description = 'National Coverage Determination';
        break;
      case 'ELV-MP':
        description = 'Elevance Medical Policies';
        break;
      case 'ELV-CG':
        description = 'Elevance Clinical Guidelines';
        break;
      case 'CMBM':
        description = 'Carelon Medical Benefits Management (CMBM)';
        break;
      default:
        description = `${criteria}`;
    }
    return description;
  }

  charactersCounter(){
    this.characterCount = this.addedText ? this.addedText.split('') : 0;
    this.characters = this.characterCount ? 500 - this.characterCount.length : 500;
  }
}
